<template>
  <div class="el-upload">
    <el-form>
      <draggable
        @start="start"
        @end="end"
        v-model="fileList"
        style="display: flex"
        :disabled="isMobile"
        :touchStartThreshold="10"
      >
        <!-- 拖拽元素 -->
        <div
          class="itemI"
          v-for="(item, index) in fileList"
          :key="item + index"
          @mouseenter="mouseenter($event, index)"
          @mouseleave="mouseleave"
        >
          <el-image
            style="width: 146px; height: 146px; border-radius: 6px"
            :src="item.url"
            :preview-src-list="[item]"
          ></el-image>
          <img
            v-if="index == 0"
            src="../../assets/zhutu.png"
            style="
              width: 68px;
              height: 68px;
              border-radius: 6px;
              z-index: 999;
              position: absolute;
              top: 0px;
              left: 0px;
            "
          />
          <div class="mark" v-if="isMark && indexM == index">
            <i
              @click="handlePictureCardPreview(item)"
              class="el-icon-zoom-in"
              style="
                color: white;
                font-size: 20px;
                margin-right: 10px;
                z-index: 9999;
              "
            ></i>
            <i
              @click="handleRemove(item, index)"
              class="el-icon-delete"
              style="color: white; font-size: 20px"
            ></i>
          </div>
        </div>
        <el-upload
          v-if="fileList.length <= 9"
          :limit="limit"
          action=""
          accept="image/*"
          :http-request="uploadFile"
          list-type="picture-card"
          :auto-upload="true"
          :file-list="fileList"
          :on-preview="handlePictureCardPreview"
          :on-exceed="handleExceed"
          :show-file-list="false"
          multiple
          ref="upload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!--        <img src="https://img-home.csdnimg.cn/images/20201124032511.png" width="146" height="146">-->
        </el-upload>
      </draggable>
      <!-- 上传按钮 -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
const qiniu = require('qiniu-js');
export default {
  components: {
    draggable
  },
  props: {
    limit: {
      type: Number,
      default: 6
    },
    list: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    list (val, vall) {
      console.log(val)
      this.fileList = val
    }
  },
  data () {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      isMark: false,
      indexM: null,
      fileList: [],
      isMobile: false
    }
  },
  mounted() {
    this.getQiniuToken()
    // 检测是否为移动端
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },
  methods: {
    mouseenter (e, index) {
      this.indexM = index
      this.isMark = true
    },
    mouseleave () {
      this.isMark = false
    },
    start (e) {
    },
    end (e) {
      this.$emit('changeImage', this.fileList)
    },
    submitUpload () { this.$refs.upload.submit() },
    uploadFile (e) {
      const file = e.file
      const isJPG = file.type === 'image/jpeg' || 'image/jpg'
      const isPNG = file.type === 'image/png'
      if (!isPNG && !isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG/JPEG 格式!')
        return false
      }

      const isLt8M = file.size / 1024 / 1024 < 8
      if (!isLt8M) {
        this.$message.error('上传图片单张大小不能超过 8MB!')
        return false
      }

      const putExtra = {
        fname: "",//文件原文件名
        params: {},//用来放置自定义变量
        mimeType: ["image/png", "image/jpeg", "image/gif"],//用来限定上传文件类型，指定null时自动判断文件类型。
      }
      const config = {
        useCdnDomain: true,//表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
        forceDirect: true, // 强制选择直传
      }
      console.log('qiniu:>>', qiniu, qiniu.upload)
      const key = "internalSystem/" + this.generateUUID();
      const observable = qiniu.upload(file, key, this.QiniuToken, putExtra, config)
      let thiz = this
      const subscription = observable.subscribe({
        next(res) {
          // console.log('next>>', res)
        },
        error(err) {
          thiz.$message.error('上传失败')
        },
        complete(res) {
          thiz.$message.success('上传成功')
          const obj = {
            url: thiz.ImgHttps + "/" + key,
            mainFlag: false
          }
          console.log(obj)
          thiz.fileList.push(obj)
          thiz.$emit('changeImage', thiz.fileList)
        },
      })


      /*const file = e.file
      const size = file.size / 1024 / 1024 / 2
      console.log(size)
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
        return
      } else if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        return
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            this.imageUrl = this.ImgHttps + res.data.url
            const obj = {
              url: this.imageUrl,
              mainFlag: false
            }
            this.fileList.push(obj)
            this.$emit('changeImage', this.fileList)
          } else {
            this.$message.error('上传失败')
          }
        })
      }*/
    },
    // 图片上传超过数量限制
    handleExceed (files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    handleRemove (file, index) {
      this.fileList.splice(index, 1)
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    // 获取七牛token
    getQiniuToken() {
      this.axios.post('/sys/v1/common/upload/ossToken').then(res => {
        console.log('>>', res)
        if (res.code === 0) {
          this.QiniuToken = res.data
        }
      })
    },
  }
}
</script>
<style lang="scss">
.el-dialog .el-dialog__header {
  border-bottom: none;
}
.itemI {
  width: 146px;
  height: 146px;
  border-radius: 6px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;
  position: relative;
  .image {
    position: absolute;
    left: 0;
    top: 0;
    width: 146px;
    height: 146px;
    border-radius: 6px;
    z-index: 1;
  }
  .mark {
    position: absolute;
    left: 0;
    top: 0;
    width: 146px;
    height: 146px;
    border-radius: 6px;
    line-height: 146px;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
// .item:hover {
//   opacity: 0.5;
// }
</style>
